import React from 'react';
import clsx from 'clsx';
import { IconButtonProps } from '../IconButton';
import { HeaderIcon } from './HeaderIcon';
import { colorGrayDusk } from '@hse-design/tokens';

export interface HeaderHamburgerProps extends IconButtonProps<'button'> {
  /**
   * Открытое состояние
   */
  isOpen?: boolean;
}

export function HeaderHamburger({
  className,
  isOpen,
  ...props
}: HeaderHamburgerProps) {
  return (
    <HeaderIcon
      className={clsx(className, { 'hse-HeaderHamburger_isOpen': isOpen })}
      component={'button'}
      {...props}
    >
      <span
        className="hse-HeaderHamburger__bars"
        style={{ color: props.iconColor ?? colorGrayDusk }}
      >
        <span className={'hse-HeaderHamburger__bar'} />
        <span className={'hse-HeaderHamburger__bar'} />
        <span className={'hse-HeaderHamburger__bar'} />
        <span
          className={clsx(
            'hse-HeaderHamburger__bar',
            'hse-HeaderHamburger__bar_cross'
          )}
        />
        <span
          className={clsx(
            'hse-HeaderHamburger__bar',
            'hse-HeaderHamburger__bar_cross'
          )}
        />
      </span>
    </HeaderIcon>
  );
}
